import { PillTypes } from './viewDiagnostics.constants';
import {
  alignRightCellStyle,
  alignCenterCellStyle,
} from '@common/cellStyles';
import { CustomDecimalRenderer } from '../../shared/numeralRenderers';
import {
  connNameColumnDefinition,
  beginingBalanceDebitColumnDefinition,
  beginingBalanceCreditColumnDefinition,
  periodNetDebitColumnDefinition,
  periodNetCreditColumnDefinition,
  glAccountColumnDefinition,
  tbBalanceColumnDefinition,
  tbCurrencyCodeColumnDefinition,
  tbBalanceMorColumnDefinition,
  tbCurrencyCodeMorColumnDefinition,
  tradingPartnerColumnDefinition,
  bookTypeColumnDefinition,
  taxYearColumnDefinition,
  diffBalanceColumnDefinition,
  diffCurrencyCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  countryCodeColumnDefinition,
  currencyCodeColumnDefinition,
} from '../../shared/columnDefinitions';

const slBalanceColumnDefinition = {
  headerName: 'SL Balance',
  field: 'slBalance',
  width: 200,
  minWidth: 80,
  cellRenderer: CustomDecimalRenderer,
  ...alignRightCellStyle,
};

const companyCodeColumnDefinition = {
  headerName: 'Company Code',
  field: 'companyCode',
  width: 200,
  minWidth: 80,
  ...alignCenterCellStyle,
};

const paymentsAndTransfersColumns = [
  connNameColumnDefinition,
  companyCodeColumnDefinition,
  {
    ...glAccountColumnDefinition,
    width: 200,
  },
  {
    ...tradingPartnerColumnDefinition,
    width: 200,
  },
  {
    ...bookTypeColumnDefinition,
    width: 100,
  },
  tbBalanceColumnDefinition,
  tbCurrencyCodeColumnDefinition,
];

const nonZeroBalancesColumns = paymentsAndTransfersColumns;

const nonMatchingBalancesColumns = paymentsAndTransfersColumns.concat([
  tbBalanceMorColumnDefinition,
  tbCurrencyCodeMorColumnDefinition,
  slBalanceColumnDefinition,
  {
    headerName: 'SL Currency Code',
    field: 'slCurrencyCode',
    width: 200,
    minWidth: 80,
    ...alignCenterCellStyle,
  },
  diffBalanceColumnDefinition,
  diffCurrencyCodeColumnDefinition,
]);

const nonMatchingBalancesSupportColumns = [
  connNameColumnDefinition,
  companyCodeColumnDefinition,
  {
    ...glAccountColumnDefinition,
    width: 200,
  },
  {
    headerName: 'SL Account',
    field: 'slAccount',
    width: 200,
    minWidth: 80,
    ...alignCenterCellStyle,
  },
  {
    ...tradingPartnerColumnDefinition,
    width: 200,
  },
  {
    ...taxYearColumnDefinition,
    width: 200,
    ...alignCenterCellStyle,
  },
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  {
    ...bookTypeColumnDefinition,
    width: 100,
  },
  {
    ...currencyCodeColumnDefinition,
    width: 100,
    minWidth: 80,
  },
  beginingBalanceDebitColumnDefinition,
  beginingBalanceCreditColumnDefinition,
  periodNetDebitColumnDefinition,
  periodNetCreditColumnDefinition,
  slBalanceColumnDefinition,
];

export const DiagnosticsColumnDefinitions = {
  paymentsAndTransfersColumns,
  nonZeroBalancesColumns,
  nonMatchingBalancesColumns,
  nonMatchingBalancesSupportColumns,
};

export default {
  [PillTypes.PAYMENTS_TRANSFERS]: paymentsAndTransfersColumns,
  [PillTypes.NON_ZERO]: paymentsAndTransfersColumns,
  [PillTypes.NON_MATCHING]: nonMatchingBalancesColumns,
  [PillTypes.NON_MATCHING_SUPPORT]: nonMatchingBalancesSupportColumns,
};
